$(document).ready(() => {
  var widgetTitleSlt = "[data-has-collapse] .widget-title";
  var sidebarLabelDesktop = ".sidebar-label-desktop";
  var viewMore = "[data-list-filter]";

  $("body")
    .off("click.toggleWidgetContent")
    .on("click.toggleWidgetContent", widgetTitleSlt, function () {
      $(this).toggleClass("open");
      $(this).next().slideToggle();
    });

  var widgetTitleSltCollNoSidebar =
    "[data-has-collapse-no-sidebar] .widget-title";
  var wrapper = $(".toolbar");

  if ($(window).innerWidth() < 1200) {
    $("body")
      .off("click.toggleWidgetContent2")
      .on(
        "click.toggleWidgetContent2",
        widgetTitleSltCollNoSidebar,
        function () {
          $(this).toggleClass("open");
          $(this).next().slideToggle();
        }
      );
    if ($(window).innerWidth() < 992) {
      $(".filters-toolbar__sortby").insertAfter(
        ".column-left .sidebar-label"
      );
    } else {
      $(".filters-toolbar__sortby").appendTo(".toolbar .column-right");
    }
    var h_wrapper = wrapper.outerHeight() + 30;
    var top = wrapper.offset().top;
    $(window).scroll(function () {
      var h = $(".sticky-wrapper.is-sticky").outerHeight();
      if ($(this).scrollTop() > top) {
        $('[data-section-type="collection-template"]').css(
          "padding-top",
          h_wrapper
        );
        wrapper.addClass("toolbar-fix");
        wrapper.css("top", 0);
      } else {
        $('[data-section-type="collection-template"]').css(
          "padding-top",
          0
        );
        wrapper.removeClass("toolbar-fix");
        wrapper.css("top", 0);
      }
    });
  } else {
    $(".filters-toolbar__sortby").appendTo(".toolbar .column-right");
    $('[data-section-type="collection-template"]').css("padding-top", 0);
    wrapper.removeClass("toolbar-fix");
    wrapper.css("top", 0);
    if ($(".collection-template-skin-1").length) {
      $(".toolbar").appendTo(".appendTo-toolbar .container");
      $("body")
        .off("click.toggleSidebar")
        .on("click.toggleSidebar", sidebarLabelDesktop, function () {
          $(this)
            .parents(".halo-collection-content")
            .toggleClass("remove-sidebar");
        });
    }
    if (
      $(".toolbar").length &&
      !$(".toolbar").hasClass("different-toolbar")
    ) {
      $(".toolbar").appendTo(".append--toolbar");
    }
  }

  $(window).resize(function () {
    if ($(window).innerWidth() < 1200) {
      $("body")
        .off("click.toggleWidgetContent2")
        .on(
          "click.toggleWidgetContent2",
          widgetTitleSltCollNoSidebar,
          function () {
            $(this).toggleClass("open");
            $(this).next().slideToggle();
          }
        );
      if ($(window).innerWidth() < 992) {
        $(".filters-toolbar__sortby").insertAfter(
          ".column-left .sidebar-label"
        );
      } else {
        $(".filters-toolbar__sortby").appendTo(".toolbar .column-right");
      }

     
    } else {
      $(".filters-toolbar__sortby").appendTo(".toolbar .column-right");
      $('[data-section-type="collection-template"]').css("padding-top", 0);
      wrapper.removeClass("toolbar-fix");
      wrapper.css("top", 0);
      $(window).scroll(function () {
        wrapper.removeClass("toolbar-fix");
      });
      if ($(".collection-template-skin-1").length) {
        $(".toolbar").appendTo(".appendTo-toolbar .container");
        $("body")
          .off("click.toggleSidebar")
          .on("click.toggleSidebar", sidebarLabelDesktop, function () {
            $(this)
              .parents(".halo-collection-content")
              .toggleClass("remove-sidebar");
          });
      }
      if (
        $(".toolbar").length &&
        !$(".toolbar").hasClass("different-toolbar")
      ) {
        $(".toolbar").appendTo(".append--toolbar");
      }
    }
  });

  $("body")
    .off("click.viewMoreFilter")
    .on("click.viewMoreFilter", viewMore, function () {
      var last = $(this).parents(".list-tags").find(".last");
      if ($(this).parents(".list-tags").hasClass("show-all")) {
        last.hide();
        $(this).text(window.inventory_text.view_more);
      } else {
        last.show();
        $(this).text(window.inventory_text.view_less);
      }
      $(this).parents(".list-tags").toggleClass("show-all");
    });
});